import React, { useState, useCallback } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import routes from '../routing/routes';

const PublicNav = () => {
  // State to track whether the navbar is expanded or not
  const [expanded, setExpanded] = useState(false);

  // Function to handle closing the navbar on link click
  const handleCollapse = useCallback(() => {
    setExpanded(false);
  }, []);

  return (
    <Navbar sticky="top" expand="lg" expanded={expanded} onToggle={setExpanded}>
      <Container>
        <Navbar.Brand as={Link} to={routes.Home.absolutePath}>
          Home
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={() => setExpanded(!expanded)} />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link as={Link} to={routes.Dashboard.absolutePath} onClick={handleCollapse}>
              Do I know you?
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default PublicNav;
